import React, { useEffect, useState } from "react";
import "./AddCompany.css";
import ApiManager from "../../ApiManager/ApiManager";

const EditCompany = ({ id, setEdit }) => {
  const [companyData, setCompanyData] = useState({
    id: "",
    username: "",
    name: "",
    address: "",
    state: "",
    zip: "",
    country: "",
    email: "",
    phoneNumber: "",
    altPhoneNumber: "",
    altEmail: "",
    remarks: "",
    financeInfo: {
      billingName: "",
      billingAddress: "",
      billingState: "",
      panNumber: "",
      gstNumber: "",
      gstType: "",
      tdsPercentage: "",
      forcedFuelType: "",
    },
  });
  const [mappedTaxTypes, setMappedTaxTypes] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);

  // Fetch initial company data
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const query = new URLSearchParams({ id: id });
        const response = await ApiManager.getCompany(query);
        if (!response.ok) throw new Error("Error fetching company details");

        const companyDetails = await response.json();
        setCompanyData({
            id: companyDetails.id,
            username: companyDetails.username,
            name: companyDetails.name,
            address: companyDetails.address,
            state: companyDetails.state,
            zip: companyDetails.zip,
            country: companyDetails.country,
            email: companyDetails.email,
            phoneNumber: companyDetails.phoneNumber,
            altPhoneNumber: companyDetails.altPhoneNumber,
            altEmail: companyDetails.altEmail,
            remarks: companyDetails.remarks,
            financeInfo: {
                billingName: companyDetails.financeInfo.billingName,
                billingAddress: companyDetails.financeInfo.billingAddress,
                billingState: companyDetails.financeInfo.billingState,
                panNumber: companyDetails.financeInfo.panNumber,
                gstNumber: companyDetails.financeInfo.gstNumber,
                gstType: companyDetails.financeInfo.gstType,
                tdsPercentage: companyDetails.financeInfo.tdsPercentage,
                forcedFuelType: companyDetails.financeInfo.forcedFuelType,
            },

        });
        // console.log("companyId: "+companyDetails.id);
        setMappedTaxTypes(companyDetails.mappedTaxTypes || []);
      } catch (error) {
        console.error("Error fetching company:", error);
      }
    };

    const fetchAllTaxTypes = async () => {
      const response = await ApiManager.getAllTaxes();
      const json = await response.json();
      setTaxTypes(json);
    };

    fetchCompanyDetails();
    fetchAllTaxTypes();
  }, [id]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompanyData({ ...companyData, [name]: value });
  };

  const handleFinanceChange = (e) => {
    const { name, value } = e.target;
    setCompanyData({
      ...companyData,
      financeInfo: { ...companyData.financeInfo, [name]: value },
    });
  };


  const handleTaxTypeToggle = (e, taxType) => {
    const { checked } = e.target;
  
    if (checked) {
      setMappedTaxTypes((prev) => [
        ...prev,
        { id: taxType.id, name: taxType.name, percentage: taxType.percentage },
      ]);
    } else {
      setMappedTaxTypes((prev) =>
        prev.filter((mappedTax) => mappedTax.id !== taxType.id)
      );
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
        id: companyData.id, // Explicitly include the id here
        username: companyData.username,
        name: companyData.name,
        address: companyData.address,
        state: companyData.state,
        zip: companyData.zip,
        country: companyData.country,
        email: companyData.email,
        phoneNumber: companyData.phoneNumber,
        altPhoneNumber: companyData.altPhoneNumber,
        altEmail: companyData.altEmail,
        remarks: companyData.remarks,
        financeInfo: {
            billingName: companyData.financeInfo.billingName,
            billingAddress: companyData.financeInfo.billingAddress,
            billingState: companyData.financeInfo.billingState,
            panNumber: companyData.financeInfo.panNumber,
            gstNumber: companyData.financeInfo.gstNumber,
            gstType: companyData.financeInfo.gstType,
            tdsPercentage: parseFloat(companyData.financeInfo.tdsPercentage),
            forcedFuelType: companyData.financeInfo.forcedFuelType,
        },
        mappedTaxTypes:
        (taxTypes && taxTypes.length > 0)
        ? taxTypes.filter((taxType) => mappedTaxTypes.some((mappedTax) => mappedTax.id === taxType.id))
            .map((taxType) => ({
                id: taxType.id,
                name: taxType.name,
                description: taxType.description,
                percentage: taxType.percentage,
            }))
        : [],
  };


    try {
    const query = new URLSearchParams({ id: id });
      const response = await ApiManager.updateCompany(query, payload);
      if (!response.ok) throw new Error("Failed to update company details");
      alert("Company details updated successfully!");
    } catch (error) {
      console.error("Error updating company:", error);
    }

    setEdit(false);
  };

  return (
    <div className="addCompany">
      <div style={{ textAlign: "center" }}>
        <h3>Edit Company</h3>
      </div>
      <form onSubmit={handleSubmit}>
        {/* Company Details Section */}
        <fieldset className="fieldset">
          <legend>Company Details</legend>
          <div className="row">
            <div className="formGroup">
              <label>Username *</label>
              <input
                type="text"
                name="username"
                value={companyData.username}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={companyData.name}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Address *</label>
              <input
                type="text"
                name="address"
                value={companyData.address}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>State *</label>
              <input
                type="text"
                name="state"
                value={companyData.state}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
        </div>
        <div className="row">
            <div className="formGroup">
              <label>Zip *</label>
              <input
                type="text"
                name="zip"
                value={companyData.zip}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Country *</label>
              <input
                type="text"
                name="country"
                value={companyData.country}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={companyData.email}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
        </div>
        <div className="row">
            <div className="formGroup">
              <label>Phone Number *</label>
              <input
                type="text"
                name="phoneNumber"
                value={companyData.phoneNumber}
                onChange={handleInputChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Alt Phone Number</label>
              <input
                type="text"
                name="altPhoneNumber"
                value={companyData.altPhoneNumber}
                onChange={handleInputChange}
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Alt Email</label>
              <input
                type="email"
                name="altEmail"
                value={companyData.altEmail}
                onChange={handleInputChange}
                className="input"
              />
            </div>
        </div>
        <div className="row">
            <div className="formGroup">
              <label>Remarks</label>
              <textarea
                name="remarks"
                value={companyData.remarks}
                onChange={handleInputChange}
                className="input"
              />
            </div>
          </div>
        </fieldset>

        {/* Finance Information Section */}
        <fieldset className="fieldset">
          <legend>Finance Info</legend>
          <div className="row">
            <div className="formGroup">
              <label>Billing Name *</label>
              <input
                type="text"
                name="billingName"
                value={companyData.financeInfo.billingName}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Billing Address *</label>
              <input
                type="text"
                name="billingAddress"
                value={companyData.financeInfo.billingAddress}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Billing State *</label>
              <input
                type="text"
                name="billingState"
                value={companyData.financeInfo.billingState}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>PAN Number *</label>
              <input
                type="text"
                name="panNumber"
                value={companyData.financeInfo.panNumber}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
        </div>
        <div className="row">
            <div className="formGroup">
              <label>GST Number *</label>
              <input
                type="text"
                name="gstNumber"
                value={companyData.financeInfo.gstNumber}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>GST Type *</label>
              <select
                name="gstType"
                value={companyData.financeInfo.gstType}
                onChange={handleFinanceChange}
                required
                className="input"
              >
                <option value="">Select GST Type</option>
                <option value="Regular">Regular</option>
                <option value="Composition">Composition</option>
              </select>
            </div>
            <div className="formGroup">
              <label>TDS Percentage *</label>
              <input
                type="number"
                name="tdsPercentage"
                value={companyData.financeInfo.tdsPercentage}
                onChange={handleFinanceChange}
                required
                className="input"
              />
            </div>
            <div className="formGroup">
              <label>Forced Fuel Type</label>
              <input
                type="text"
                name="forcedFuelType"
                value={companyData.financeInfo.forcedFuelType}
                onChange={handleFinanceChange}
                className="input"
              />
            </div>
          </div>
        </fieldset>


        {/* Tax Types Section */}
        <fieldset className="fieldset">
        <legend>Tax Types</legend>
        {taxTypes && taxTypes.length > 0 ? (
            taxTypes.map((taxType) => (
            <div key={taxType.id} className="formGroup">
                <label>
                <input
                    type="checkbox"
                    name={`taxType_${taxType.id}`}
                    checked={mappedTaxTypes.some((mappedTax) => mappedTax.id === taxType.id)}
                    onChange={(e) => handleTaxTypeToggle(e, taxType)}
                />
                {taxType.name} ({taxType.percentage}%)
                </label>
            </div>
            ))
        ) : (
            <div className="formGroup">
            <p>No tax types available.</p>
            </div>
        )}
        </fieldset>

        {/* Submit Button */}
        <button type="submit" className="submitButton">
          Submit
        </button>
      </form>
    </div>
  );
};

export default EditCompany;
